<div class="modal-header">
    <h4 class="modal-title">Session Timeout</h4>
</div>
<div class="modal-body">
    <p>Your session will expire in {{ remainingCountdown }} seconds.</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="extendSession()">Extend Session</button>
    <button type="button" class="btn btn-danger" (click)="logout()">Logout</button>
</div>